import { ActionReducerMap } from '@ngrx/store';

import * as fromRouter from '@ngrx/router-store';
import * as fromAuth from './auth.reducer';
import * as fromFilter from './filter.reducer';
import * as fromUser from './user.reducer';
import * as fromDelivery from './delivery.reducer';
import * as fromDeliveryAsset from './delivery-assets.reducer';
import * as fromRouterHistory from './router-history.reducer';
import * as fromOffline from './offline.reducer';
import { RouterStateUrl } from '../../models';
import { accountSettingsReducer, AccountSettings } from './account-settings.reducer';
import * as appSettingsReducer from '../../../settings/application-settings/store/application-settings.reducer';

export interface State {
  auth: fromAuth.AuthState;
  filter: fromFilter.Filter;
  user: fromUser.UserState;
  router: fromRouter.RouterReducerState<RouterStateUrl>;
  delivery: fromDelivery.DeliveryState;
  deliveryAssets: fromDeliveryAsset.DeliveryAssetState;
  routerHistory: fromRouterHistory.RouterHistory;
  accountSettings: AccountSettings;
  [fromOffline.offlineFeatureKey]: fromOffline.OfflineState;
  [appSettingsReducer.reducerKey]: appSettingsReducer.ApplicationSettings;
}

export const reducers: ActionReducerMap<State> = {
  auth: fromAuth.reducer,
  filter: fromFilter.filterReducer,
  user: fromUser.userReducer,
  router: fromRouter.routerReducer,
  delivery: fromDelivery.reducer,
  deliveryAssets: fromDeliveryAsset.reducer,
  routerHistory: fromRouterHistory.reducer,
  accountSettings: accountSettingsReducer,
  [fromOffline.offlineFeatureKey]: fromOffline.reducer,
  [appSettingsReducer.reducerKey]: appSettingsReducer.applicationSettingsReducer,
};
